import React, { ChangeEvent } from "react";
import * as Styled from "../settingStyles";
import { GOSwitch } from "../../../components";
import { UserManager } from "../../../actions";
import { useTranslation } from "react-i18next";

type etcSettingProps = {
  settingData: any;
  setSettingData: any;
  save: boolean;
  setSave: any;
  edit: boolean;
};

const EtcSettings = ({
  settingData,
  setSettingData,
  save,
  setSave,
  edit
}: etcSettingProps) => {
  const { t } = useTranslation();
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSave(false);
    console.log(value.slice(0, 2));
    if (parseInt(value) < 1) setSettingData({ ...settingData, [name]: "1" });
    else setSettingData({ ...settingData, [name]: value.slice(0, 2) });
  };

  const handleChangeSelect = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setSave(false);

    if (parseInt(value) < 1) setSettingData({ ...settingData, [name]: "1" });
    else setSettingData({ ...settingData, [name]: value.slice(0, 2) });
  };

  return (
    <Styled.BoxWrapper>
      {/*<div className="subTitle">기타 설정</div>*/}
      <div className="subTitle">{t("setting.etc")}</div>
      <div className="box-list">
        <div className="box">
          <div className="inner">
            <div className="label">{t("setting.maxPauseCount")}</div>
            <Styled.Flexbox>
              <Styled.Input
                name="maxPauseCount"
                type="number"
                onChange={handleChange}
                value={settingData?.maxPauseCount || ""}
                disabled={edit}
                required
              />
              <Styled.Unit>{t("setting.times")}</Styled.Unit>
            </Styled.Flexbox>
          </div>
          <div className="description">
            <div>{t("setting.maxPauseCountDescription")}</div>
            <div>{t("setting.maxPauseCountDescription2")}</div>
          </div>
        </div>
        <div className="box">
          <div className="inner">
            <div className="label">{t("setting.checkinTime")}</div>
            <Styled.Flexbox>
              <Styled.Input
                name="checkinTime"
                type="number"
                onChange={handleChange}
                value={settingData?.checkinTime || ""}
                disabled={edit}
                required
                style={{ width: "100px", paddingRight: "53px" }}
              />
              <Styled.Unit>{t("trans.hoursBefore")}</Styled.Unit>
            </Styled.Flexbox>
          </div>
          <div className="description">
            <div>{t("setting.message1")}</div>
            <div>{t("setting.message2")}</div>
            <div>{t("setting.message3")}</div>
          </div>
        </div>
        {(UserManager().getUser()?.branch.id === 1 ||
          UserManager().getUser()?.branch.id === 13) &&
          settingData.multipleSelectionMaxLimit && (
            <div className="box">
              <div className="inner">
                <div className="label">{t("setting.message4")}</div>
                <div>
                  <Styled.Flexbox>
                    <Styled.SelectBox
                      name="multipleSelectionMaxLimit"
                      onChange={handleChangeSelect}
                      value={settingData.multipleSelectionMaxLimit}
                      disabled={edit}
                    >
                      <option value={1}>{t("setting.count1")}</option>
                      <option value={2}>{t("setting.count2")}</option>
                      <option value={3}>{t("setting.count3")}</option>
                    </Styled.SelectBox>
                  </Styled.Flexbox>
                </div>
              </div>
              <div className="description" style={{ marginTop: "0px" }}>
                <div>{t("setting.message5")}</div>
                <div>{t("setting.message6")}</div>
              </div>
            </div>
          )}
      </div>
    </Styled.BoxWrapper>
  );
};

export default EtcSettings;
